import React, { Component } from 'react'
import styled from 'styled-components'
import { Input, Popconfirm, Button, Form, Collapse, Icon } from 'antd'
import moment from 'moment'
import ContactsCollapse from './Collapse'

const { Panel } = Collapse
const FormItem = Form.Item

const AddItemsContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`

class Notes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      attachmentDetailsVisible: false
    }
  }

  onNoteInputChange = e => {
    this.setState({
      noteContent: e.target.value
    })
  }

  renderElement = note => {
    const { handleRowNoteClick } = this.props
    const { id, content, created_date } = note
    const createdDate = moment.utc(created_date).format('M/D/YYYY')
    const contentHeader = content.length < 100 ? content : content.slice(0, 100).trim() + '...'
    return (
      <Panel key={id} header={contentHeader}>
        <div className="row">
          <div className="col-md-6">
            <div className="jobDetailsHeader">Content:</div>
            <span>{content}</span>
          </div>
          <div className="col-md-4">
            <div className="jobDetailsHeader">Created:</div>
            <span>{createdDate}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Edit:</div>
            <Button onClick={() => handleRowNoteClick(note)}>
              <Icon type="edit" />
            </Button>
          </div>
        </div>
      </Panel>
    )
  }

  handleAddEditNote = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      if (this.props.currentNote) {
        values.updated_by_id = this.props.userId
        values.updated_date = moment().format('YYYY/MM/DD HH:mm:ss')

        this.props.updateNote(values)
      } else {
        values.created_by_id = this.props.userId
        values.updated_by_id = this.props.userId
        values.created_date = moment().format('YYYY/MM/DD HH:mm:ss')

        this.props.createNote(values)
      }

      form.resetFields()
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { noteAddEditContainer, deleteNote } = this.props
    const notes = this.props.notes || []
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                <h4>Notes</h4>
              </div>
              <div className="col-md-6 d-flex justify-content-end">
                <Button
                  icon="plus"
                  onClick={() => this.props.handleToggleNoteEditArea()}
                  className="ml-2"
                >
                  {' '}
                  Add Note
                </Button>
              </div>
            </div>
            {noteAddEditContainer && (
              <AddItemsContainer>
                <Form>
                  <div className="row">
                    <div className="col-md-12">
                      <FormItem label="Content">
                        {getFieldDecorator('content', {
                          rules: [
                            {
                              required: true,
                              message: 'Content cannot be blank.'
                            }
                          ],
                          initialValue: this.props.currentNote ? this.props.currentNote.content : ''
                        })(<Input />)}
                      </FormItem>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <Popconfirm
                        title="Are you sure you want to delete this record?"
                        onConfirm={deleteNote}
                        onCancel={this.cancelDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        {this.props.currentNote && (
                          <Button type="danger" icon="delete" className="mr-2" />
                        )}
                      </Popconfirm>
                      <Button onClick={() => this.handleAddEditNote()}>
                        {this.props.currentNote ? 'Edit' : 'Add'}
                      </Button>
                    </div>
                  </div>
                </Form>
              </AddItemsContainer>
            )}
            <ContactsCollapse emptyText="There are no notes for this contact">
              {notes.map(this.renderElement)}
            </ContactsCollapse>
          </div>
        </div>
      </div>
    )
  }
}

export default Form.create()(Notes)



// WEBPACK FOOTER //
// ./src/components/contacts/Notes.js